import { v2, Languages } from '../../../..';

export const getLanguageMapping = (language: Languages): v2.TLanguageType | null => {
    const languageKey = Object.entries(Languages).find(([, value]) => value === language)?.[0];

    if (!languageKey) {
        return null;
    }

    return v2.LanguageType[languageKey as keyof typeof v2.LanguageType];
};
